function assert(item) {
    if (!item) {
        throw Error("PageIndicator not yet initialized");
    }
}
class PageIndicator {
    constructor({ className, carousel }) {
        this.pageIndicatorItems = [];
        this.carousel = carousel;
        this.className = className;
        this.classes = {
            active: `${this.className}__page-indicator__item--active`,
            wrapper: `${this.className}__page-indicator-wrapper`,
            flex: `${this.className}__page-indicator-flex`,
            item: `${this.className}__page-indicator__item`,
            big: "",
        };
        this.classes.big = `${this.classes.item}--big`;
    }
    create({ total, index }) {
        const pageIndicatorWrapper = document.createElement("div");
        pageIndicatorWrapper.classList.add(this.classes.wrapper);
        const pageIndicatorFlex = document.createElement("div");
        pageIndicatorFlex.classList.add(this.classes.flex);
        const pageIndicator = document.createElement("ul");
        pageIndicator.classList.add(`${this.className}__page-indicator`);
        this.pageIndicatorItems = [...Array(total)].map((_, i) => {
            const title = `go to ${i + 1}/${total}`;
            const li = document.createElement("li");
            li.elementIndex = i;
            li.classList.add(this.classes.item, i === index ? this.classes.active : this.classes.item);
            li.classList.add(this.classes.item, total < 7 ? this.classes.big : this.classes.item);
            const button = document.createElement("button");
            button.setAttribute("type", "button");
            button.title = title;
            li.title = title;
            li.appendChild(button);
            pageIndicator.appendChild(li);
            return li;
        });
        pageIndicatorWrapper.appendChild(pageIndicatorFlex);
        pageIndicatorFlex.appendChild(pageIndicator);
        const carousel = this.carousel.getElement();
        /*                                                                    */
        const old = carousel.querySelector(`.${this.classes.wrapper}`);
        if (old) {
            carousel.replaceChild(pageIndicatorWrapper, old);
        }
        else {
            carousel.appendChild(pageIndicatorWrapper);
        }
        /*                           */
        pageIndicator.addEventListener("touchstart", (event) => {
            event.preventDefault();
        });
        pageIndicator.addEventListener("click", (event) => {
            const target = event.target.closest(`.${this.className}__page-indicator__item`);
            event.preventDefault();
            if (target) {
                this.carousel.move({ index: target.elementIndex, source: "pageIndicator" });
            }
        });
        this.pageIndicatorElement = pageIndicator;
        this.translate({ index, scrollingRight: true });
        return this;
    }
    update({ index, scrollingRight }) {
        var _a;
        assert(this.pageIndicatorElement);
        (_a = this.pageIndicatorElement
            .querySelector(`.${this.classes.active}`)) === null || _a === void 0 ? void 0 : _a.classList.remove(this.classes.active);
        this.pageIndicatorItems[index].classList.add(this.classes.active);
        this.translate({
            index,
            scrollingRight,
        });
    }
    translate({ index, scrollingRight }) {
        if (this.pageIndicatorItems.length > 6) {
            const max = this.pageIndicatorItems.length;
            let translate;
            const rightEdge = max - 4;
            const leftEdge = 4;
            const width = 12;
            const gap = 3;
            this.pageIndicatorItems.forEach((item, i) => {
                item.classList.remove(this.classes.big);
                if (index > rightEdge && i > rightEdge - gap) {
                    /*                         */
                    item.classList.add(this.classes.big);
                }
                else if (index < leftEdge && i < leftEdge + gap - 1) {
                    /*                        */
                    item.classList.add(this.classes.big);
                }
                else if (i > index - gap && i < index + gap) {
                    /*                      */
                    item.classList.add(this.classes.big);
                }
            });
            /*                           */
            if (scrollingRight) {
                if (index > rightEdge) {
                    translate = this.pageIndicatorItems[max - 7].offsetLeft;
                }
                else if (index > 2) {
                    translate = this.pageIndicatorItems[index].offsetLeft - gap * width;
                }
            }
            else if (index > gap && index < rightEdge) {
                translate = this.pageIndicatorItems[index].offsetLeft - gap * width;
            }
            else if (index < leftEdge) {
                translate = 0;
            }
            if (typeof translate !== "undefined" && this.pageIndicatorElement) {
                this.pageIndicatorElement.style.transform = `translateX(-${translate}px)`;
            }
        }
    }
}

class Arrows {
    constructor({ window, className, prev, next, total, carousel, }) {
        /**
 *
 *
 *
 *
 *
 */
        this.delay = 500;
        this.window = window;
        this.className = className;
        this.total = total;
        this.prev = prev;
        this.next = next;
        this.classes = {
            hiddenArrow: `${this.className}__arrow--hidden`,
            airbag: `${this.className}__arrow--airbag`,
        };
        this.carousel = carousel;
    }
    init() {
        [this.prev, this.next].forEach((arrow) => {
            arrow.addEventListener("click", (e) => {
                e.preventDefault();
                if (arrow === this.next) {
                    this.carousel.scrollNext({
                        source: "arrowRight",
                    });
                }
                else {
                    this.carousel.scrollPrev({
                        source: "arrowLeft",
                    });
                }
            });
        });
        return this;
    }
    airbag(arrow) {
        arrow.classList.add(this.classes.hiddenArrow);
        arrow.classList.add(this.classes.airbag);
        this.window.setTimeout(() => {
            arrow.classList.remove(this.classes.airbag);
        }, this.delay);
    }
    hideArrows() {
        [this.prev, this.next].forEach((el) => {
            el.classList.add(this.classes.hiddenArrow);
        });
    }
    update({ index, total }) {
        if (index === 0) {
            this.airbag(this.prev);
        }
        else {
            this.prev.classList.remove(this.classes.hiddenArrow);
        }
        if (index === total - 1) {
            this.airbag(this.next);
        }
        else {
            this.next.classList.remove(this.classes.hiddenArrow);
        }
    }
}

/*                                             */
function hasScrollBehaviour(window) {
    return "scrollBehavior" in window.document.documentElement.style;
}

/**
 *
 *
 *
 */
const computeAmountOfVisibleSlides = ({ stage, slides, }) => {
    const st = stage.getBoundingClientRect();
    const accumulator = [];
    /*                                                      */
    slides.every((s) => {
        const sl = s.getBoundingClientRect();
        if (sl.left >= st.left && sl.right <= st.right) {
            accumulator.push(s);
            return true;
        }
        /*                                                */
        /*                            */
        return accumulator.length === 0;
    });
    return accumulator.length;
};

const CINEMA_EVENTS = {
    initialized: "assets.cinema.initialized",
    visible: "assets.cinema.visible",
    change: "assets.cinema.change",
    updated: "assets.cinema.updated",
};
const CAROUSEL_EVENTS = {
    initialized: "assets.slidingcarousel.initialized",
    visible: "assets.slidingcarousel.visible",
    change: "assets.slidingcarousel.change",
    updated: "assets.slidingcarousel.updated",
};
class SlidingCarousel {
    constructor(window, element, className) {
        var _a;
        this.lastScrollLeft = 0;
        this.wait = [];
        this.edge = 0;
        this.total = 0;
        this.hasEdge = false;
        this.initialized = false;
        this.isCinema = false;
        this.visibleSlideIndices = new Set();
        this.className = className;
        this.carousel = element;
        this.isCinema = this.className.includes("pl_cinema");
        if (this.isCinema) {
            const noEdgeAttributeValue = this.carousel.getAttribute("data-pl-cinema-no-edges");
            this.hasEdge = !(noEdgeAttributeValue && !noEdgeAttributeValue.includes("false"));
        }
        this.classes = {
            ready: `${this.className}--ready`,
            activeSlide: `${this.className}__slide--active`,
            arrow: `${this.className}__arrow`,
            fallback: `${this.className}--fallback`,
            stage: `${this.className}__stage`,
            noRubberband: "",
            noSmoothScrolling: `${this.className}--no-scroll-smoothing`,
            noArrows: `${this.className}--no-arrows`,
        };
        this.classes.noRubberband = `${this.classes.stage}--no-rubberband`;
        this.slides = Array.from(this.carousel.querySelectorAll(`.${this.className}__slide`)).map((slide, index) => {
            slide.elementIndex = index;
            return slide;
        });
        this.stage = this.carousel.querySelector(`.${this.classes.stage}`);
        /*                                                               */
        this.activeSlideIndex =
            ((_a = Array.from(this.slides).filter((slide) => {
                return slide.classList.contains(this.classes.activeSlide);
            })[0]) === null || _a === void 0 ? void 0 : _a.elementIndex) || 0;
        this.lastActiveSlideIndex = this.activeSlideIndex;
        this.window = window;
        this.observerOptions = {
            root: this.stage,
            threshold: this.calculateObserverThreshold(),
        };
        this.eventsCinema = window.o_global.events();
        this.eventsCarousel = window.o_global.events();
        SlidingCarousel.instances.set(element, this);
        /*                                                                               */
        /*                                                  */
        /*                                                        */
        /*                                                                           */
        /*                                  */
        if (this.isCinema && this.stage.clientWidth >= this.stage.scrollWidth) {
            this.carousel.classList.add(this.classes.noArrows);
            /*                             */
            this.hasEdge = false;
        }
    }
    getNumberOfVisibleSlides() {
        const res = this.isCinema
            ? computeAmountOfVisibleSlides({
                stage: this.stage,
                slides: this.slides,
            })
            : 1;
        return res;
    }
    static getInstance(element) {
        return SlidingCarousel.instances.get(element);
    }
    static getAllInstances() {
        return Array.from(SlidingCarousel.instances.values());
    }
    getElement() {
        return this.carousel;
    }
    scrollNext({ source }) {
        let next = this.activeSlideIndex + this.getNumberOfVisibleSlides();
        if (next >= this.total) {
            next = this.total - 1;
        }
        this.move({ index: next, source });
    }
    scrollPrev({ source }) {
        let prev = this.activeSlideIndex - this.getNumberOfVisibleSlides();
        if (this.getNumberOfVisibleSlides() > 1 && this.lastActiveSlideIndex === this.total - 1) {
            prev = this.lastActiveSlideIndex - 2 * this.getNumberOfVisibleSlides() + 2;
        }
        if (prev < 0) {
            prev = 0;
        }
        this.move({ index: prev, source });
    }
    calculateObserverThreshold() {
        const largestSlideWidth = Math.max(...this.slides.map((slide) => slide.getBoundingClientRect().width));
        const maxWidth = this.window.innerWidth;
        if (this.isCinema) {
            return maxWidth >= largestSlideWidth ? 1.0 : maxWidth / largestSlideWidth;
        }
        return maxWidth >= largestSlideWidth / 2 ? 0.5 : maxWidth / largestSlideWidth;
    }
    emitCinemaChangeEvent(event, data) {
        if (!this.isCinema) {
            return;
        }
        this.eventsCinema.emit(event, data);
    }
    emitCarouselChangeEvent(event, data) {
        if (this.isCinema) {
            return;
        }
        this.eventsCarousel.emit(event, data);
    }
    emitAllChangeEvents({ source, index, scrollingRight, }) {
        const basePayload = {
            element: this.carousel,
            source,
            scrollingRight,
        };
        /*                              */
        if (this.isCinema) {
            this.emitCinemaChangeEvent(CINEMA_EVENTS.updated, {
                ...basePayload,
                currentSlides: [...this.visibleSlideIndices],
            });
        }
        else {
            this.emitCarouselChangeEvent(CAROUSEL_EVENTS.updated, {
                ...basePayload,
                currentSlide: index,
            });
        }
        /*                                                                   */
        this.wait.push(this.window.setTimeout(() => {
            this.wait.pop();
            if (this.wait.length === 0) {
                if (this.isCinema) {
                    this.emitCinemaChangeEvent(CINEMA_EVENTS.change, {
                        ...basePayload,
                        currentSlides: [...this.visibleSlideIndices],
                    });
                }
                else {
                    this.emitCarouselChangeEvent(CAROUSEL_EVENTS.change, {
                        ...basePayload,
                        currentSlide: index,
                    });
                }
            }
        }, 1000));
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    update({ index }) {
        var _a, _b, _c;
        const scrollingRight = index >= this.lastActiveSlideIndex;
        this.activeSlideIndex = index;
        this.lastSource || (this.lastSource = "touch");
        if (index !== this.lastActiveSlideIndex) {
            this.emitAllChangeEvents({ index, scrollingRight, source: this.lastSource });
        }
        this.lastSource = undefined;
        this.lastActiveSlideIndex = this.activeSlideIndex;
        (_a = this.pageIndicator) === null || _a === void 0 ? void 0 : _a.update({ index, scrollingRight });
        (_b = this.arrows) === null || _b === void 0 ? void 0 : _b.update({
            index,
            total: this.total,
        });
        (_c = this.carousel
            .querySelector(`.${this.classes.activeSlide}`)) === null || _c === void 0 ? void 0 : _c.classList.remove(this.classes.activeSlide);
        this.slides[index].classList.add(this.classes.activeSlide);
    }
    isIntersecting(entry) {
        return entry.isIntersecting && entry.intersectionRatio >= this.observerOptions.threshold;
    }
    onIntersectionObserverUpdate(entries) {
        /*                                                                                        */
        /*                                                                                                     */
        if (!this.stage.matches("body *") || this.stage.scrollLeft === this.lastScrollLeft) {
            return;
        }
        const isScrollingRight = this.lastScrollLeft < this.stage.scrollLeft;
        this.lastScrollLeft = this.stage.scrollLeft;
        entries
            /*                                                                   */
            /*                                                */
            /*                                                         */
            .sort((a, b) => {
            const indexA = a.target.elementIndex;
            const indexB = b.target.elementIndex;
            return isScrollingRight ? indexA - indexB : indexB - indexA;
        })
            .forEach((entry) => {
            const { elementIndex } = entry.target;
            let index = isScrollingRight && this.getNumberOfVisibleSlides() > 2
                ? elementIndex - this.getNumberOfVisibleSlides() + 1
                : elementIndex;
            if (this.isIntersecting(entry) && this.slides[index]) {
                this.visibleSlideIndices.add(elementIndex);
                /*                                                              */
                if (index > this.total - 1 - this.getNumberOfVisibleSlides()) {
                    index = this.total - 1;
                }
                this.update({
                    index,
                });
            }
            else {
                this.visibleSlideIndices.delete(elementIndex);
            }
        });
    }
    onIntersectionObserverVisibilityCheck(entries) {
        entries.some((entry) => {
            if (entry.intersectionRatio > 0 && entry.intersectionRatio < 1) {
                /*                                                                            */
                this.edge = entry.intersectionRect.width + 16 + (this.hasEdge ? 16 : 0);
                return true;
            }
            return false;
        });
        entries.forEach((entry) => {
            var _a;
            (_a = this.visibleObserver) === null || _a === void 0 ? void 0 : _a.unobserve(entry.target);
            if (entry.intersectionRatio === 1) {
                this.visibleSlideIndices.add(entry.target.elementIndex);
            }
        });
        const basePayload = {
            element: this.carousel,
        };
        if (this.isCinema) {
            const cinemaPayload = {
                ...basePayload,
                currentSlides: [...this.visibleSlideIndices],
            };
            if (!this.initialized) {
                this.eventsCinema.emit("assets.cinema.initialized", cinemaPayload);
            }
            else {
                this.eventsCinema.emit("assets.cinema.visible", cinemaPayload);
            }
        }
        else {
            const carouselPayload = {
                ...basePayload,
                currentSlide: this.activeSlideIndex,
            };
            if (!this.initialized) {
                this.eventsCarousel.emit("assets.slidingcarousel.initialized", carouselPayload);
            }
            else {
                this.eventsCarousel.emit("assets.slidingcarousel.visible", carouselPayload);
            }
        }
        this.initialized = true;
    }
    /**
 *
 *
 */
    move({ index, source = "move", noScrollSmoothing, }) {
        if (!this.slides[index]) {
            console.error(`index out of bound: ${index}`);
            return;
        }
        /*                                 */
        if (index === this.lastActiveSlideIndex) {
            return;
        }
        if (noScrollSmoothing) {
            this.carousel.classList.add(this.classes.noSmoothScrolling);
        }
        this.stage.scrollLeft = this.slides[index].offsetLeft - (this.hasEdge ? this.edge / 2 : 0);
        this.lastSource = source;
        if (noScrollSmoothing) {
            this.carousel.classList.remove(this.classes.noSmoothScrolling);
        }
    }
    init() {
        var _a;
        /*                                                                          */
        this.carousel.classList.remove(this.classes.ready);
        this.observerOptions = {
            root: this.stage,
            threshold: this.calculateObserverThreshold(),
        };
        /*                                     */
        this.observer = new IntersectionObserver((el) => {
            this.onIntersectionObserverUpdate(el);
        }, this.observerOptions);
        this.visibleObserver =
            /*                                     */
            new IntersectionObserver(this.onIntersectionObserverVisibilityCheck.bind(this), this.observerOptions);
        /**
 *
 *
 */
        if (!hasScrollBehaviour(this.window)) {
            this.carousel.classList.add(this.classes.fallback);
        }
        this.total = this.slides.length;
        if (this.total < 1) {
            throw new Error("minimum amount of slides must be 1");
        }
        this.pageIndicator =
            this.carousel.dataset.cinemaHidePageindicator ||
                this.carousel.dataset.slidingCarouselHidePageIndicator ||
                this.total < 2
                ? undefined
                : new PageIndicator({ className: this.className, carousel: this }).create({
                    total: this.total,
                    index: this.activeSlideIndex,
                });
        const [prev, next] = Array.from(this.carousel.querySelectorAll(`.${this.classes.arrow}`));
        if (next && prev) {
            this.arrows = new Arrows({
                window,
                className: this.className,
                prev,
                next,
                total: this.total,
                carousel: this,
            }).init();
        }
        if (this.total === this.getNumberOfVisibleSlides()) {
            (_a = this.arrows) === null || _a === void 0 ? void 0 : _a.hideArrows();
        }
        this.update({ index: this.activeSlideIndex });
        /*                                                   */
        if (this.total >= 2) {
            this.carousel.addEventListener("keyup", (e) => {
                const { key } = e;
                if (key === "ArrowLeft") {
                    this.scrollPrev({
                        source: "KeyArrowLeft",
                    });
                }
                else if (key === "ArrowRight") {
                    this.scrollNext({
                        source: "KeyArrowRight",
                    });
                }
            });
        }
        /*                                                      */
        this.stage.scrollLeft = this.slides[this.activeSlideIndex].offsetLeft - (this.hasEdge ? 16 : 0);
        this.slides[this.activeSlideIndex].classList.add(this.classes.activeSlide);
        this.carousel.classList.add(this.classes.ready);
        this.slides.forEach((slide) => {
            var _a;
            (_a = this.observer) === null || _a === void 0 ? void 0 : _a.observe(slide);
        });
        this.slides.forEach((slide) => {
            var _a;
            (_a = this.visibleObserver) === null || _a === void 0 ? void 0 : _a.observe(slide);
        });
        return this;
    }
}
/*                                                                  */
SlidingCarousel.instances = new Map();

export { SlidingCarousel };
